import { CategoriaFiltroDTO, ICategoriaFiltroDTO } from "./CategoriaFiltro.DTO";
import { Nilable } from "@shared/utils";
import { ItemPreguntaDTO } from "./ItemPregunta.DTO";
import { RegionDTO } from "./Region.DTO";

export interface ITagDTO {
    id: number;
    value: Nilable<string>;
    type?: Nilable<ICategoriaFiltroDTO>;
    type_id?: number;
    category: Nilable<string>;
    items_id: Nilable<number[]>;
    regions_id: Nilable<number[]>;
}

export class TagDTO {
    public id = 0;
    public valor = "";
    public categoria = "";
    public tipo = new CategoriaFiltroDTO();
    public items: ItemPreguntaDTO[] = [];
    public regiones: RegionDTO[] = [];

    constructor(json: Nilable<Partial<ITagDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ITagDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.value != null) {
            this.valor = json.value;
        }
        if (json.type_id != null) {
            this.tipo = new CategoriaFiltroDTO({ id: json.type_id });
        }
        if (json.type != null) {
            this.tipo = new CategoriaFiltroDTO(json.type);
        }
    }

    public toJSON(): ITagDTO {
        const json = {
            id: this.id,
            value: this.valor,
            type_id: this.tipo.id
        } as ITagDTO;

        if (this.categoria !== "") {
            json.category = this.categoria;
        }
        if (this.items.length !== 0) {
            json.items_id = this.items.map(item => item.id);
        }
        if (this.regiones.length !== 0) {
            json.regions_id = this.regiones.map(item => item.id);
        }
        return json;
    }
}
